import {Box, Typography, lighten} from '@mui/material';
import {node, object, string} from 'prop-types';
import React from 'react';

export const ChipAndLabel = ({color, label, sx = {}}) => (
  <Box
    sx={[
      {
        display: 'inline-flex',
        alignItems: 'center',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Box
      sx={{
        marginRight: 0.5,
        width: '1em',
        height: '1em',
        display: 'inline-block',
        backgroundColor: theme =>
          theme.palette[color]?.light
            ? theme.palette[color]?.light
            : lighten(color[500], 0.5),
        border: 'solid 2px',
        borderColor: theme =>
          theme.palette[color]?.main ? theme.palette[color].main : color[500],
      }}
    />
    <Typography component="span" sx={{fontWeight: 'normal', fontSize: 12}}>
      {label}
    </Typography>
  </Box>
);

ChipAndLabel.propTypes = {
  color: string,
  label: node,
  sx: object,
};
